import React from 'react'
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import AppButton from './AppButton'

const styles = {
    summary: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', flex: '1 1 200px', minWidth: 0, columnGap: 1 },
    selectAll: { textTransform: 'none', whiteSpace: 'normal', textAlign: 'left' },
}

export default function GridSelectionActions({ count, total, filtered = false, canSelectAll = false, allSelected = false, disabled = false, onDelete, onClear, onSelectAll }) {
    const hasSelection = count > 0
    const scope = filtered ? 'matching ' : ''
    return (
        <>
            <Tooltip title='Clear selection'>
                <span>
                    <IconButton aria-label='Clear selection' disabled={disabled || !hasSelection} onClick={onClear}>
                        <ClearIcon fontSize='small' />
                    </IconButton>
                </span>
            </Tooltip>
            <Box sx={styles.summary}>
                <Typography variant='body2' fontWeight={600} color={hasSelection ? 'text.primary' : 'text.disabled'} role='status' aria-live='polite' aria-atomic='true'>
                    {`${count} selected${allSelected ? ` across all ${scope}pages` : ''}`}
                </Typography>
                <Tooltip title={`Delete selected rows (${count})`}>
                    <span>
                        <AppButton aria-label='Delete selected' color='error' size='small' startIcon={<DeleteOutlineIcon fontSize='small' />} disabled={disabled || !hasSelection} onClick={onDelete}>
                            Delete
                        </AppButton>
                    </span>
                </Tooltip>
                {canSelectAll && (
                    <Button size='small' disabled={disabled} onClick={onSelectAll} sx={styles.selectAll}>
                        {`Select all ${total} ${scope}rows`}
                    </Button>
                )}
            </Box>
        </>
    )
}
